export class PopupDropdownParameters<T>
{
    public items: T[];
    public labelKey: keyof T;
}
